<template>
  <section class="navbar">
    <div class="navbar__container">
      <a :href="Content.en_gb.navbar.logoLink"><img src="../assets/images/just-eat-logo.svg"  alt="justeat" class="navbar__container--logo"></a>
    </div>
  </section>
</template>
<script>
import Content from "../data/content.js";

export default {

  name: "Navbar",


  data: function () {
    return {
      Content
    }
  }


};
</script>



<style lang="scss">
$desktop: 1024px;
$tablet: 768px;
$mobile: 600px;

.navbar {
  margin-bottom: -10px;
  background-color: var(--color-orange-1);
  padding: 20px 5%;
  display: flex;
  justify-content: flex-start;
  position: relative;
  z-index: 2;

  &__container {
    max-width: 1250px;
    margin: 0 auto;
  }

  img {
    max-height: 69px;
  }
}
</style>